import {
    IAttributes,
    IAugmentedJQuery,
    ICacheFactoryService,
    ICacheObject,
    IComponentOptions,
    IController,
    IHttpService,
    IModule,
    IOnChangesObject
} from "angular";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";

/**
 * Viser bilde lastet fra server via xhr.
 * Merk at koden benytter  URL.createObjectURL(..) som krever IE11, Edge, Safari 10, IOS 9.3
 * se http://caniuse.com/#search=createObjectURL
 */
export function registrerXhrImgKomponent(angular: IModule) {
    angular
        .component('fkXhrImg', tipsKomponentDef());
}

function tipsKomponentDef(): IComponentOptions {
    return {
        bindings: {
            url: "<"
        },
        controller: XhrImgKontroller.forInjisering(),
        template: '<img class="{{$ctrl.$attrs.imgClass}}">'
    };
}

export class XhrImgKontroller implements IController {
    static forInjisering() {
        return [
            regNavn.ng.$element,
            regNavn.ng.$attrs,
            regNavn.ng.$http,
            regNavn.ng.$cacheFactory,
            XhrImgKontroller
        ]
    }

    constructor(private $element: IAugmentedJQuery, public $attrs: IAttributes, private $http: IHttpService, private $cacheFactory: ICacheFactoryService) {
        this.initCache();
        this.img = this.$element.find("img");
    }

    img: IAugmentedJQuery;
    objectUrl: string;

    private cache: ICacheObject;

    $onChanges(changes: IOnChangesObject) {
        const url = changes['url'].currentValue;
        if (url) this.lastBilde(url);
    }

    $onDestroy() {
        URL.revokeObjectURL(this.objectUrl);
    }

    //hjelpemetoder

    private initCache() {
        this.cache = this.$cacheFactory.get('fkXhrImg');
        if (!this.cache)
            this.cache = this.$cacheFactory('fkXhrImg', {capacity: 100});
    }

    private lastBilde(url: string) {
        if (url.indexOf('data:') === 0) {
            this.img.attr('src', url);
            return;
        }

        this.$http.get<ArrayBuffer>(url, {
            responseType: 'arraybuffer',
            headers: {'accept': 'image/*'},
            cache: this.cache
        })
            .then(response => {
                const blob = new Blob(
                    [response.data],
                    {type: response.headers('Content-Type')}
                );
                URL.revokeObjectURL(this.objectUrl);
                this.objectUrl = URL.createObjectURL(blob);
                this.img.attr('src', this.objectUrl);
            });
        //.catch(e=>console.log("fkXhrImg er "+ e));
    }

}
